import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import AdministratorAndRolesTable from '~/components/pages/Admin/Administrator/organisms/AdministratorAndRolesTable';
import { FONT_SIZES } from '~/assets/styles/base';
import { callThunk, fetchAdminAndRoles, fetchRoles } from '~/api';
import PageLinkBar from '~/components/ui-parts/PageLinkBar';
import { ROUTES } from '~/constants/routes';
import { ADMIN_ROLES } from '~/common/constants';
import { LOCAL_STORAGES } from '~/constants';

const UsersWrapper = styled.div`
  width: 100%;
  text-align: center;
  padding: 0 185px;
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`;

const Title = styled.span`
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

function AdministratorsAndRoles() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const adminAndRoles = useSelector((state) => state.adminAndRoles);
  const roles = useSelector((state) => state.roles);

  const link = [
    {
      label: t('appCommon.adminBackHome'),
      routePath: ROUTES.ADMIN.MYPAGE,
    },
    {
      label: '',
      routePath: '',
    },
  ];

  useEffect(() => {
    const adminRoles = localStorage.getItem(LOCAL_STORAGES.ADMIN_ROLES)?.split(',');
    if (!(adminRoles && adminRoles.includes(ADMIN_ROLES.ACCOUNT_MANAGEMENT_ROLE.toString()))) {
      navigate(ROUTES.ADMIN[403]);
    } else {
      dispatch(
        callThunk({
          action: fetchAdminAndRoles,
        })
      );
      dispatch(
        callThunk({
          action: fetchRoles,
        })
      );
    }
  }, []);

  return (
    <UsersWrapper>
      <PageLinkBar links={link} />
      <TitleWrapper>
        <Title>{t('administratorAndRoles.title')}</Title>
      </TitleWrapper>
      <AdministratorAndRolesTable administratorsAndRoles={adminAndRoles} roles={roles} />
    </UsersWrapper>
  );
}

export default AdministratorsAndRoles;
